/* ==========================================================================
   Copargo - Rotador vertical de anuncios (QA1)
   --------------------------------------------------------------------------
   Custom de Copargo. No toca hdt-slider ni ningun componente del tema base.

   <copargo-announcement-rotator data-interval="4000" data-pause-on-hover>
     <div class="copargo-annr__viewport">
       <div class="copargo-annr__track">
         <div class="copargo-annr__item">...</div>
         ...
       </div>
     </div>
   </copargo-announcement-rotator>

   Responsabilidades:
   1. Medir el mensaje mas alto y bloquear la altura del viewport en
      --copargo-annr-h. Con eso la barra no cambia de alto al rotar y el
      sticky del header (--announcement-bar-height) no salta.
   2. Rotar en autoplay: el nuevo entra desde arriba y empuja al anterior
      hacia abajo (la animacion vive en el CSS).
   3. Pausar en hover (si el setting lo pide), con la pestana oculta, y
      mientras el cliente edita bloques en el customizer.

   prefers-reduced-motion se respeta en el CSS: sigue rotando, pero el
   cambio es instantaneo. Aca no se duplica la logica.
   ========================================================================== */

(function () {
  "use strict";

  // Debe coincidir con la transicion de copargo-announcement-vertical.css
  var TRANSITION_MS = 550;

  if (typeof customElements === "undefined") return;
  if (customElements.get("copargo-announcement-rotator")) return;

  class CopargoAnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector(".copargo-annr__viewport");
      this.track = this.querySelector(".copargo-annr__track");
      this.items = Array.prototype.slice.call(
        this.querySelectorAll(".copargo-annr__item"),
      );

      if (!this.viewport || !this.track || this.items.length === 0) return;

      this.index = 0;
      this.timer = null;
      this.parkTimer = null;
      this.measureTimer = null;
      this.pending = null;
      this.hovering = false;
      this.editing = false;

      var raw = parseInt(this.getAttribute("data-interval"), 10);
      this.interval = isNaN(raw) ? 0 : raw;
      this.pauseOnHover = this.hasAttribute("data-pause-on-hover");

      // Un solo mensaje: nada que rotar ni que estabilizar.
      if (this.items.length < 2) return;

      // Orden importante: is-live PRIMERO. Mientras la clase no esta puesta,
      // el CSS oculta todos los mensajes menos el primero (para evitar el
      // flash sin JS), y esa regla tambien alcanzaria a los clones de la
      // sonda, midiendo 0px todo lo que no sea el primer mensaje.
      this.classList.add("is-live");
      this.items[0].setAttribute("data-state", "current");
      this.measure();

      this.bind();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      clearTimeout(this.parkTimer);
      clearTimeout(this.measureTimer);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.onVisibility) {
        document.removeEventListener("visibilitychange", this.onVisibility);
      }
    }

    // ----------------------------------------------------------------------
    // Medicion: alto del mensaje mas alto, con el ancho real del viewport
    // ----------------------------------------------------------------------
    measure() {
      var width = this.viewport.clientWidth;
      if (!width) return;

      var probe = document.createElement("div");
      probe.className = "copargo-annr__probe";
      probe.setAttribute("aria-hidden", "true");
      probe.style.width = width + "px";

      this.items.forEach(function (item) {
        var clone = item.cloneNode(true);
        clone.removeAttribute("data-state");
        // El clon no debe heredar ids ni hooks del customizer
        clone.removeAttribute("id");
        clone.removeAttribute("data-shopify-editor-block");
        probe.appendChild(clone);
      });

      this.viewport.appendChild(probe);

      var max = 0;
      Array.prototype.forEach.call(probe.children, function (child) {
        if (child.offsetHeight > max) max = child.offsetHeight;
      });

      probe.remove();

      if (max > 0) {
        this.style.setProperty("--copargo-annr-h", max + "px");
      }
    }

    remeasure() {
      var self = this;
      clearTimeout(this.measureTimer);
      this.measureTimer = setTimeout(function () {
        self.measure();
      }, 120);
    }

    // ----------------------------------------------------------------------
    // Eventos
    // ----------------------------------------------------------------------
    bind() {
      var self = this;

      // El ancho cambia -> el texto reflowea -> hay que remedir
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(function () {
          self.remeasure();
        });
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener("resize", function () {
          self.remeasure();
        });
      }

      // Albert Sans carga async: al aplicarse cambian las metricas del texto
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          self.remeasure();
        });
      }

      if (this.pauseOnHover) {
        this.addEventListener("mouseenter", function () {
          self.hovering = true;
          self.stop();
        });
        this.addEventListener("mouseleave", function () {
          self.hovering = false;
          self.start();
        });
      }

      // No rotar en una pestana que no se ve.
      // Al volver a ser visible hay que remedir: si la ventana cambio de
      // ancho mientras estaba oculta, el navegador no entrega las
      // notificaciones del ResizeObserver (no hay ciclo de render) y la
      // altura bloqueada se quedaria con el valor del ancho anterior.
      this.onVisibility = function () {
        if (document.hidden) {
          self.stop();
        } else {
          self.remeasure();
          self.start();
        }
      };
      document.addEventListener("visibilitychange", this.onVisibility);

      // Customizer: al seleccionar un bloque hay que mostrar ESE mensaje
      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener("shopify:block:select", function (event) {
          self.editing = true;
          self.stop();
          var i = self.items.indexOf(
            event.target.closest(".copargo-annr__item"),
          );
          if (i > -1) self.goTo(i);
        });
        this.addEventListener("shopify:block:deselect", function () {
          self.editing = false;
          self.start();
        });
      }
    }

    // ----------------------------------------------------------------------
    // Autoplay
    // ----------------------------------------------------------------------
    start() {
      this.stop();
      if (this.interval <= 0) return;
      if (this.hovering || this.editing || document.hidden) return;

      var self = this;
      this.timer = setInterval(function () {
        self.goTo((self.index + 1) % self.items.length);
      }, this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    // ----------------------------------------------------------------------
    // Transicion vertical: el nuevo baja desde arriba, el viejo es empujado
    // ----------------------------------------------------------------------
    goTo(next) {
      if (next === this.index) return;
      if (next < 0 || next >= this.items.length) return;

      // Si quedo un saliente sin reposicionar, resolverlo ya
      this.park();

      var outgoing = this.items[this.index];
      var incoming = this.items[next];

      outgoing.setAttribute("data-state", "leaving");
      incoming.setAttribute("data-state", "current");
      this.index = next;

      // Terminada la animacion, el saliente vuelve arriba sin animarse
      var self = this;
      this.pending = outgoing;
      this.parkTimer = setTimeout(function () {
        self.park();
      }, TRANSITION_MS);
    }

    // Devuelve el saliente a su posicion de espera (arriba) sin animacion
    park() {
      clearTimeout(this.parkTimer);
      this.parkTimer = null;

      var el = this.pending;
      if (!el) return;
      this.pending = null;

      el.classList.add("copargo-annr--noanim");
      el.removeAttribute("data-state");
      void el.offsetHeight; // forzar reflow para que el salto no se anime
      el.classList.remove("copargo-annr--noanim");
    }
  }

  customElements.define(
    "copargo-announcement-rotator",
    CopargoAnnouncementRotator,
  );
})();
